module.exports = __webpack_public_path__ + "img/92.dd8fc773.jpg";